import { requestTemplate } from 'api';
import { ISimpleGroupForAprove } from 'interfaces';


export type AgreementInitiator = {
  id: string;
  user_name: string;
  email: string;
};

export type ArgeementState = {
  id: string;
  entity: string;
  agreement_state?: ISimpleGroupForAprove[];
  comment?: string;
  author?: any;
  status?: 0 | 1 | 2 | null;
  initiator_id?: string;
  initiator?: AgreementInitiator;
};

//AGREEMENT
const addAgreement = (
  payload: ArgeementState
) => requestTemplate.post<string>(`/agreement/`, payload);

const deleteAgreement = (
  payload: { id: string, entity: string }
) => requestTemplate.delete<string>(`/agreement/`, { data: payload });

const getAgreements = (
  id: string, entity: string
) => requestTemplate.get<ArgeementState[]>(`/agreement/?id=${id}&entity=${entity}`);

const logExportAgreementState = (
  p: {room_id: string, entity_id: string, action_type?: string, log_type?: string, }
) => requestTemplate.post(
  `/public/log/?room_id=${p.room_id}&entity_id=${p.entity_id}&action_type=${p.action_type}&log_type=${p.log_type}`
);

const addAgreementParticipants = (
  payload: { entity_id: string; entity: string; agreement_state: ISimpleGroupForAprove[] }
) => requestTemplate.post<void>('/agreement/participants/', payload);

const deleteAgreementParticipants = (
  payload: { entity_id: string; entity: string; user_ids: string[] }
) => requestTemplate.delete<void>('/agreement/participants/', { data: payload });

const agreement = {
  addAgreement,
  deleteAgreement,
  getAgreements,
  logExportAgreementState,
  addAgreementParticipants,
  deleteAgreementParticipants,
};

export default agreement;
